import { CommonModule } from '@angular/common'
import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
} from '@angular/core'
import { ProfileJumbotronComponent } from 'src/app/components/profile-jumbotron/profile-jumbotron.component'
import { WindowRef } from 'src/app/providers/WindowRef'
import { CacheService } from 'src/app/services/cache.service'
import { PurchaseHistoryService } from 'src/app/services/purchase-history.service'
import sdk from '@sp400/sdk'
import { LoadingService } from 'src/app/services/loading.service'
import { TranslationService } from '../../services/translation.service'

@Component({
  selector: 'purchase-history',
  standalone: true,
  imports: [CommonModule, ProfileJumbotronComponent],
  templateUrl: './purchase-history.component.html',
  styleUrl: './purchase-history.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [WindowRef],
})
export class PurchaseHistoryComponent implements OnInit {
  flag: boolean = false
  userProfile: any = {}
  originalDataList:any
  dataList: any = []
  cdr = inject(ChangeDetectorRef)
  downloadSvg = `<space-icon icon="save" outline=true class="hydrated"></space-icon>`
  _translationsPurchaseList: any
  originalPurchaseList: any = []
  _purchaseList: Array<any> = []
  pageNum: number = 0
  translationProductDescription:any
  isDateAsc:boolean=false
  isDateDsc:boolean=false
  isInvoiceAsc:boolean=false
  isInvoiceDsc:boolean=false
  searchText:string=""
  constructor(
    private windowRef: WindowRef,
    private purchaseService: PurchaseHistoryService,
    private _loading: LoadingService,
    private cacheService: CacheService,
    private translationService: TranslationService,
  ) {}
  ngOnInit() {
    this._loading.showLoading()
    this.translationProductDescription =
    this.translationService.getTranslationForPage('purchase_history')
   
    sdk.get('authentication.profile', null).then((value) => {
      console.log('uData: ', value)
      this.userProfile = {
        ...value.data.profile,
        ...value.data.data,
      }
      this.cdr.markForCheck()
    })

    this.purchaseList(this.dataList)
    this.purchaseService.getPurchaseHistory()
    this.purchaseService.products$.subscribe((data: any) => {
      this.originalPurchaseList = data.data.invoices
      this.dataList = data.data.invoices
      this.originalDataList=JSON.parse(JSON.stringify(data.data.invoices))
      this.purchaseList(this.dataList)
      this._loading.hideLoading()
      this.flag = true
      this.cdr.markForCheck()
    })
  }
  printPage() {
    this.windowRef.nativeWindow.print()
  }
  sortByData() {
    console.log('hey i am sorting')
  }
  splitProductInPage(arr: Array<any>, chunkSize: number): Array<Array<any>> {
    let result: Array<Array<any>> = []
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize))
    }
    return result
  }
  purchaseList(value: Array<any>) {
    this.originalPurchaseList = value
    this._purchaseList = this.splitProductInPage(
      value,
      this.originalPurchaseList.length
    )

    this.cdr.markForCheck()
  }

  nextPage() {
    if (this.pageNum < this._purchaseList.length - 1) this.pageNum++
  }

  prevPage() {
    if (this.pageNum > 0) this.pageNum--
  }

  findBy(searchValue: any) {
    searchValue = searchValue.target['value'].toLowerCase()
    this.searchText=searchValue
    if(this.searchText!=undefined){
    this.dataList=JSON.parse(JSON.stringify(this.originalDataList)).filter(
      (item: any) =>
        item['subscriptions'][0]['vin'].toLowerCase().includes(this.searchText) ||
        this.changeDateFormat(item['invoiceTargetDate'])
          .toLowerCase()
          .includes(this.searchText) ||
        item['invoiceNumber'].toLowerCase().includes(this.searchText) ||
        item['subscriptions'][0]['ProductName']
          .toLowerCase()
          .includes(this.searchText)
    )
  }
    if(this.isDateAsc){
      this.dataList = this.dataList.sort(
        (a: any, b: any) =>
          new Date(a.invoiceTargetDate).getTime() -
          new Date(b.invoiceTargetDate).getTime()
      )
    }
    else if(this.isDateDsc){
      this.dataList = this.dataList.sort(
        (a: any, b: any) =>
          new Date(b.invoiceTargetDate).getTime() -
          new Date(a.invoiceTargetDate).getTime()
      )
    }
    else if(this.isInvoiceAsc){
      this.dataList = this.dataList.sort((a: any, b: any) =>
        a.invoiceNumber < b.invoiceNumber
          ? -1
          : a.invoiceNumber > b.invoiceNumber
          ? 1
          : 0
      )
    }

    else if(this.isInvoiceDsc){
      this.dataList = this.dataList.sort((a: any, b: any) =>
        a.invoiceNumber < b.invoiceNumber
          ? 1
          : a.invoiceNumber > b.invoiceNumber
          ? -1
          : 0
      )
    }
    this.purchaseList(this.dataList)
    this.cdr.markForCheck()
  }
  sortByDate(data: any) {
    console.log(data, 'sort data')
    if (data == 'asc') {
      if(!this.isDateAsc){
      this.dataList = this.dataList.sort(
        (a: any, b: any) =>
          new Date(a.invoiceTargetDate).getTime() -
          new Date(b.invoiceTargetDate).getTime()
      )
    }
    else{
      this.dataList=JSON.parse(JSON.stringify(this.originalDataList))
    }
      this.isDateAsc=!this.isDateAsc
      this.isDateDsc=false
      this.isInvoiceAsc=false
      this.isInvoiceDsc=false
    } else {
    if(!this.isDateDsc){
      this.dataList = this.dataList.sort(
        (a: any, b: any) =>
          new Date(b.invoiceTargetDate).getTime() -
          new Date(a.invoiceTargetDate).getTime()
      )
    }
    else{
       this.dataList=JSON.parse(JSON.stringify(this.originalDataList))

    }
      this.isDateDsc=!this.isDateDsc
      this.isDateAsc=false
      this.isInvoiceAsc=false
      this.isInvoiceDsc=false
    }
    if(this.searchText!=undefined){
    this.dataList = this.dataList.filter(
      (item: any) =>
        item['subscriptions'][0]['vin'].toLowerCase().includes(this.searchText) ||
        this.changeDateFormat(item['invoiceTargetDate'])
          .toLowerCase()
          .includes(this.searchText) ||
        item['invoiceNumber'].toLowerCase().includes(this.searchText) ||
        item['subscriptions'][0]['ProductName']
          .toLowerCase()
          .includes(this.searchText)
    )
  }
    this.purchaseList(this.dataList)
   
    this.cdr.markForCheck()
  }

  sortByInvoice(data: any) {
  
    if (data == 'asc') {
     if(!this.isInvoiceAsc){
      this.dataList = this.dataList.sort((a: any, b: any) =>
        a.invoiceNumber < b.invoiceNumber
          ? -1
          : a.invoiceNumber > b.invoiceNumber
          ? 1
          : 0
      )
    }
    else{
      this.dataList=JSON.parse(JSON.stringify(this.originalDataList))

    }
      this.isDateDsc=false
      this.isDateAsc=false
      this.isInvoiceAsc=!this.isInvoiceAsc
      this.isInvoiceDsc=false
    } else {
     if(!this.isInvoiceDsc){
      this.dataList = this.dataList.sort((a: any, b: any) =>
        a.invoiceNumber < b.invoiceNumber
          ? 1
          : a.invoiceNumber > b.invoiceNumber
          ? -1
          : 0
      )
    }
    else{
      this.dataList=JSON.parse(JSON.stringify(this.originalDataList))

    }
      this.isDateDsc=false
      this.isDateAsc=false
      this.isInvoiceAsc=false
      this.isInvoiceDsc=!this.isInvoiceDsc
    }
    console.log(this.dataList)
    if(this.searchText!=undefined){
    this.dataList = this.dataList.filter(
      (item: any) =>
        item['subscriptions'][0]['vin'].toLowerCase().includes(this.searchText) ||
        this.changeDateFormat(item['invoiceTargetDate'])
          .toLowerCase()
          .includes(this.searchText) ||
        item['invoiceNumber'].toLowerCase().includes(this.searchText) ||
        item['subscriptions'][0]['ProductName']
          .toLowerCase()
          .includes(this.searchText)
    )
  }
    this.purchaseList(this.dataList)
    this.cdr.markForCheck()
  }
  changeDateFormat(data: any) {
    let tempArray = data.split('-')
    return `${tempArray[2]}/${tempArray[1]}/${tempArray[0]}`
  }
}
